import React from 'react';
import { getOrgTermsContent } from '../content/utils.js';

const initiativeSurveyImg = (
  <img
    src="../../../static/images/surveys.webp"
    alt="surveys empty state img"
    sizes="432x324"
    style={{ maxWidth: '432px' }}
  />
);
const initiativeLinkedFilesImg = (
  <img
    src="../../../static/images/linked-files.webp"
    alt="linked-files empty state img"
    sizes="432x324"
    style={{ maxWidth: '432px' }}
  />
);
const changeImpactsImg = (
  <img
    src="../../../static/images/change-impacts.webp"
    alt="change-impacts empty state img"
    sizes="432x324"
    style={{ maxWidth: '432px' }}
  />
);
const linkedFilesImg = (
  <img
    src="../../../static/images/linked-files.webp"
    alt="linked-files empty state img"
    sizes="432x324"
    className="empty-img"
    style={{ maxWidth: '432px' }}
  />
);
const stakeholdersImg = (
  <img
    src="../../../static/images/stakeholders.webp"
    alt="stakeholders empty state img"
    sizes="432x324"
    className="empty-img"
    style={{ maxWidth: '432px' }}
  />
);
const orgStakeholdersImg = (
  <img
    src="../../../static/images/org-stakeholders.png"
    alt="org stakeholders empty state img"
    sizes="433x324"
    className="empty-img"
    style={{ maxWidth: '432px' }}
  />
);
const orgStructureImg = (
  <img
    src="../../../static/images/org-structure.png"
    alt="org structure empty state img"
    sizes="433x324"
    className="empty-img"
    style={{ maxWidth: '432px' }}
  />
);
const changeStrategyImg = (
  <img
    src="../../../static/images/empty-strategy.png"
    alt="org stakeholders empty state img"
    sizes="433x324"
    className="empty-img"
    style={{ maxWidth: '432px' }}
  />
);
const surveyEmptyResponsesImg = (
  <img
    src="../../../static/images/survey-response.png"
    alt="Feedback Form empty state img"
    sizes="433x324"
    className="empty-img"
    style={{ maxWidth: '432px' }}
  />
);
const surveyAnalysisEmptyImg = (
  <img
    src="../../../static/images/ai-empty-state-image.png"
    alt="Feedback Form empty state img"
    sizes="433x324"
    className="empty-img"
    style={{ maxWidth: '432px' }}
  />
);
const surveyThanYouImg = (
  <img
    src="../../../static/images/survey-response.png"
    alt="Feedback Form response empty state img"
    sizes="302x324"
    className="empty-img"
    style={{ maxWidth: '302px' }}
  />
);
const surveyLateResponseImg = (
  <img
    src="../../../static/images/survey-late-response.png"
    alt="Feedback Form response late state img"
    sizes="302x324"
    className="empty-img"
    style={{ maxWidth: '302px' }}
  />
);
const onlineEventImg = (
  <img
    src="../../../static/images/online-events-response.png"
    alt="Online event invite img"
    sizes="302x324"
    className="empty-img"
    style={{ maxWidth: '302px' }}
  />
);
const employeesImg = (
  <img
    src="../../../static/images/employees.png"
    alt="employees empty state img"
    sizes="432x324"
    className="empty-img"
    style={{ maxWidth: '432px' }}
  />
);
const notFoundImg = (
  <img
    src="../../../static/images/error-not-found.png"
    alt="Online event invite img"
    sizes="302x324"
    className="empty-img"
    style={{ maxWidth: '302px' }}
  />
);
const portfoliosEmpty = (
  <img
    src="../../../static/images/portfolios-empty.png"
    alt="Portfolios img"
    sizes="432x324"
    className="empty-img"
  />
);
const noTemplateImg = (
  <img
    src="../../../static/images/no-template.png"
    alt="No Templates img"
    sizes="432x324"
    className="empty-img"
  />
);

export const initiativeSurveyContent = {
  image: initiativeSurveyImg,
  title: getOrgTermsContent('initiativeChangeInsightEmptyTitle'),
  subtitle:
    'Surveys and Assessments are an integral tool in any change management toolkit because they provide critical insight about how people feel about a change process and where change leaders can be more effective, relevant, or strategic.',
  paragraphFirst: getOrgTermsContent('initiativeChangeInsightEmptyDescription'),
  actionLabel: 'Add Feedback Form',
};

export const initiativeLinkedFilesContent = {
  image: initiativeLinkedFilesImg,
  title: 'Start Adding Linked Files!',
  subtitle:
    "Think of Linked Files as shortcuts to your organization's repositories like Teams, SharePoint, or Dropbox.",
  paragraphFirst:
    'Linking files in ChangeSync eliminates the time you spend looking for key items and important documents across multiple systems.',
  paragraphSecond: `${getOrgTermsContent('initiativeLinkedFilesParagraphSecond')}`,
  paragraphThird:
    'Once added, people can easily find, download, and use the support materials and documents created for them - in one easy place!',
  actionLabel: 'Add Linked File',
};

export const changeImpactContent = {
  image: changeImpactsImg,
  title: 'Start Adding Change Impacts!',
  subtitle:
    'Change Impacts are the incremental changes that must occur in order for the larger change to take hold.',
  paragraphFirst:
    'They are categorized by: type, organized by the individuals and/or groups impacted, and provide specific details of what needs to be done to support the larger change at-hand.',
  paragraphSecond:
    'In addition, they are used to plan communication, engagement, and training strategies.',
  paragraphThird:
    'Capturing and understanding change impacts helps change leaders reduce risks and challenges associated with a change.',
  actionLabel: 'Add Change Impact',
};

export const linkedFilesContent = {
  image: linkedFilesImg,
  title: 'Start Adding Linked Files!',
  subtitle:
    "Think of Linked Files as shortcuts to your organization's repositories like Teams, SharePoint, or Dropbox.",
  paragraphFirst:
    'Linking files in ChangeSync eliminates the time you spend looking for key items and important documents across multiple systems.',
  paragraphSecond: getOrgTermsContent('initiativeLinkedFilesParagraphSecond'),
  paragraphThird:
    'Once added, people can easily find, download, and use the support materials and documents created for them - in one easy place!',
  actionLabel: 'Add Linked File',
};

export const stakeholdersContent = {
  image: stakeholdersImg,
  title: 'Start Adding Stakeholders!',
  subtitle:
    'Stakeholders are the people, groups, or roles affected by the change or interested in the change.',
  paragraphFirst:
    'Examples include: employees, subject-matter experts, leaders, and executives.',
  paragraphSecond:
    "It's important to identify and understand the unique motivations, expectations, and needs of your stakeholders in order to leverage and engage them appropriately throughout the change journey.",
  paragraphThird:
    'Completing a stakeholder analysis will help you identify and target key groups according to their influence, interest, and predicted impact related to the change.',
  actionLabel: 'Add Stakeholder',
};

export const orgStakeholdersContent = {
  image: orgStakeholdersImg,
  title: 'Start Adding Organizational Stakeholders!',
  paragraphFirst: getOrgTermsContent('orgStakeholdersContentParagraphFirst'),
  paragraphSecond: `The Organizational Stakeholder Structure greatly enhances your reporting capabilities. It empowers you to generate comprehensive reports that provide insights and analysis on stakeholder engagement and involvement across the entirety of your change ${getOrgTermsContent('portfolio')}. This enterprise-level reporting not only allows you to monitor stakeholder activity and progress but also enables you to identify patterns, trends, and areas of change improvement, ultimately enhancing the success of your change management efforts.`,
  actionLabel: 'Create Organization Stakeholders',
};

export const orgStructureContent = {
  image: orgStructureImg,
  title: 'Start building your Organizational Structure!',
  subtitle:
    'In ChangeSync, the Primary Organizational Structure plays a vital role in reflecting how your business operates and is organized, including departments, roles, regions, locations, and more.',
  paragraphFirst:
    'This structure serves as the foundation for reporting, tracking, analysis, and assignment capabilities within ChangeSync. The Primary Organizational Structure in ChangeSync is designed to be flexible, allowing you to configure it to match your unique organizational hierarchy.',
  paragraphSecond:
    'By leveraging this structure, you gain comprehensive reporting capabilities that empower you to monitor and analyze the performance, progress, and impact of your workforce across different areas of your organization. It enables you to make data-driven decisions, identify areas of change improvement, and allocate resources effectively.',
  actionLabel: 'Create Organization Structure',
};

export const changeStrategyContent = {
  image: changeStrategyImg,
  title: 'Start Building Your Change Strategy!',
  subtitle: getOrgTermsContent('changeStrategyContentSubtitle'),
  paragraphFirst: getOrgTermsContent('changeStrategyContentParagraphFirst'),
  paragraphSecond:
    'At a glance, this document will also help others understand your governance structure by clearly identifying different areas of accountability, responsibility, and support. It serves as a communication tool to engage critical stakeholders, fostering trust, reducing resistance, and encouraging collaboration.',
  paragraphThird: getOrgTermsContent('changeStrategyContentParagraphThird'),
  actionLabel: 'Create Change Strategy',
};

export const noResultsWithImpactsDescContent = {
  title: 'No Results',
  description: 'Adjust your filters to query for more change impacts.',
};

export const noResultsWithProjectsDescContent = {
  title: 'No Results',
  description: getOrgTermsContent('noProjectsResult'),
};

export const noResultsWithCIDescContent = {
  title: 'No Results',
  description: 'Adjust your filters to query for more change impacts.',
};

export const noResultsContent = {
  title: 'No Results',
};

export const loadingContent = {
  title: 'Loading...',
};

export const loadingReportContent = {
  title: 'Hang tight!',
  description: "We're preparing your data...",
};

export const permissionsOwnUserContent = {
  title:
    'Users cannot delete or edit their own permissions. Please contact your System Administrator if you need to edit your permissions. If you are a System Administrator, please contact your ChangeSync Account Manager.',
};

export const permissionsAddNewRoleContent = {
  title:
    'Click the "Add New Role" button to begin assigning the user\'s organization and security role(s).',
};

export const surveyWaitingContent = {
  image: surveyEmptyResponsesImg,
  title: 'Waiting for Responses!',
  paragraphFirst:
    "Your feedback has been sent. Don't worry if this page looks empty right now! Data will appear as soon as recipients start submitting their responses.",
};

export const surveyThankResponseContent = {
  image: surveyThanYouImg,
  title: 'Thank you!',
  paragraphFirst: 'Your responses have been submitted!',
  paragraphSecond:
    'We appreciate your valuable insights and candid responses. Participant feedback will guide us in making meaningful, continuous improvements to the change process.',
};

export const surveyReceivedContent = {
  image: surveyThanYouImg,
  title: 'Your Feedback Form Responses Have Been Received.',
  paragraphFirst:
    'You have already submitted your responses. Thank you for your participation.',
};

export const noTemplateContent = {
  image: noTemplateImg,
  subtitle:
    'There are no pre-made surveys or assessments in your ChangeSync toolkit.',
  paragraphFirst:
    "To create a one-time survey for this activity, click 'Create Feedback Form.'",
  paragraphSecond:
    "For reusable survey or assessment templates, go to Organization > Custom Settings > ChangeInsights Hub. Click 'Add Feedback Form,' then save and publish it. Your new form will be available for reuse across all of ChangeSync for any change management activity you create.",
};

export const onlineEventInviteResponseContent = {
  image: onlineEventImg,
  title: 'Event Invitation has been sent',
  paragraphFirst:
    'The invitation for the event has been successfully sent to all the attendees via email. They should receive the details shortly.',
};

export const surveyResponseAlreadyExistContent = {
  image: surveyThanYouImg,
  title: 'Your Survey/Assessment Responses Have Been Received.',
  paragraphFirst:
    'You have already submitted your responses. Thank you for your participation',
};

export const surveyDoesntExistContent = {
  image: surveyThanYouImg,
  title: 'The feedback form you are looking for does not exist.',
  paragraphFirst:
    'It is possible that there was a typo in the link or the form was deleted.',
};

export const surveyLateContent = {
  image: surveyLateResponseImg,
  title: 'Thank you for your interest in providing feedback',
  paragraphFirst:
    'Unfortunately, the feedback period has ended, and we are no longer accepting responses. Your input is valuable to us, and we encourage you to stay engaged for future opportunities to share your thoughts.',
};

export const surveyAnalysisDoesntExistContent = {
  image: surveyAnalysisEmptyImg,
  title: 'Start Using AI to Analyze Feedback!',
  paragraphFirst:
    'Use our AI helper to analyze participant feedback and quickly gain insight into key themes and trends!',
  paragraphSecond:
    'This powerful feature allows you to review, re-prompt, and save results ensuring they provide meaningful and actionable outcomes.',
  paragraphThird:
    'Start by clicking the “Add AI Analysis” button and the analysis will automatically begin!',
  actionLabel: 'Add AI Analysis',
};

export const surveyAnalysisDoesntExistSurveyContent = {
  image: initiativeSurveyImg,
  title: getOrgTermsContent('initiativeChangeInsightAIEmptyTitle'),
  subtitle:
    'Surveys and Assessments are an integral tool in any change management toolkit because they provide critical insight about how people feel about a change process and where change leaders can be more effective, relevant, or strategic.',
  paragraphFirst: getOrgTermsContent(
    'initiativeChangeInsightAIEmptyTitleDescription'
  ),
  actionLabel: 'Add Feedback Form',
};

export const surveyAnalysisNoResponsesContent = {
  image: initiativeSurveyImg,
  title: 'Awaiting Insights',
  paragraphFirst: 'It seems the results haven’t yet arrived.',
  paragraphSecond:
    'Don’t worry, as soon as feedback starts flowing in, you’ll be able to uncover valuable insights and trends.',
};

export const surveyAnalysisDatesContent = {
  image: initiativeSurveyImg,
  title: 'Awaiting Insights',
  subtitle: 'Great insights are worth the wait!',
  paragraphFirst:
    'Your results are being gathered and will be available for analysis after the feedback form’s end date.',
  paragraphSecond:
    'In the meantime, rest assured that every response is being carefully gathered and recorded, and will be available to provide the insights you seek.',
};

export const employeesContent = {
  image: employeesImg,
  title: 'Add Your Employee Reporting Structure',
  paragraphFirst:
    "It looks like there is no Employee Reporting Structure or employee names configured for this page yet. Don't worry, setting up your Employee Reporting Structure is easy, and you'll be able to manage employee information seamlessly. For each employee, specify their reporting manager and any direct reports.",
  paragraphSecond:
    'The Employee Reporting Structure is crucial for understanding employees, teams, titles, and reporting relationships. The system will track where they sit within the organization. This makes it easier to appropriately track employees across critical change activities and efforts.',
  actionLabel: 'Add Employee',
};

export const portfoliosContent = {
  image: portfoliosEmpty,
};

export const initiativesWidgetContent = {
  subtitle: `Nothing to Show yet.`,
  description: `Add your first ${getOrgTermsContent('initiative')} to start tracking progress.`,
  actionLabel: `View ${getOrgTermsContent('initiatives')}`,
};

export const initiativeStatusesWidgetContent = {
  subtitle: `Nothing to Show yet.`,
  description: `Add your first ${getOrgTermsContent('initiative')} to see the breakdown.`,
  actionLabel: `View ${getOrgTermsContent('initiatives')}`,
};

export const peopleEngagementWidgetContent = {
  subtitle: `Nothing to Show yet.`,
  description: `Assign people to change ${getOrgTermsContent('initiatives')} to track engagement.`,
  actionLabel: `View ${getOrgTermsContent('initiatives')}`,
};

export const impactedPeopleWidgetContent = {
  subtitle: `Nothing to Show yet.`,
  description: `Link groups, stakeholders, and employees to see the overview.`,
  actionLabel: `View Change Impacts`,
};

export const changeImpactTasksWidgetContent = {
  subtitle: `Nothing to Show yet.`,
  description: `Break down your change impacts into tasks to get started.`,
  actionLabel: `View Change Impacts`,
};

export const projectMilestonesWidgetContent = {
  subtitle: `Nothing to Show yet.`,
  description: `Add milestones to keep your ${getOrgTermsContent('project')} on track.`,
  actionLabel: `View Change Strategy`,
};

export const feedbackIntelligenceWidgetContent = {
  subtitle: `Nothing to Show yet.`,
  description: `Launch a pulse survey to start collecting feedback.`,
  actionLabel: `View ${getOrgTermsContent('initiatives')}`,
};

export const stakeholdersOverviewWidgetContent = {
  subtitle: `Nothing to Show yet.`,
  description: `Add stakeholders to monitor support and engagement.`,
  actionLabel: `View Stakeholder Analysis`,
};

export const stakeholderSupportDistributionWidgetContent = {
  subtitle: `Nothing to Show yet.`,
  description: `Add stakeholders and assign support levels to see the distribution.`,
  actionLabel: `View Stakeholder Analysis`,
};
